
<template>
    <img 
        ref="image"
        :class="[loaded ? 'loaded' : 'loading']"
        :src="imgSrc"
        @load="onImageLoaded"
        draggable="false" 
    />
</template>


<script>
// Use IntersectionObserver to know if image is within viewport - https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
// Inspiration: https://github.com/kevindesousa/vue-image-loader


export default {
    props: {
        data: {
            type: Array,
            required: true,

            // EXAMPLE data - Array with src, widht & height
            // [
            //     {
            //         "url": "https://source.unsplash.com/collection/3657445/768x432",
            //         "width": 768,
            //         "height": 432
            //     },
            //     {
            //         "url": "https://source.unsplash.com/collection/3657445/1080x608",
            //         "width": 1080,
            //         "height": 608
            //     },
            //     {
            //         "url": "https://source.unsplash.com/collection/3657445/1920x1080",
            //         "width": 1920,
            //         "height": 1080
            //     }
            // ]
        },

        // We load image sizes depending on container width. containerWidth is updated on resize.
        containerWidth: {
            type: Number,
            required: true,
        }
    },


    data() {
        return {
            src: '',
            imgSrc: false,
            observer: null,
            intersected: false,
            loaded: false
        }
    },

    mounted() {
        
        // https://caniuse.com/#search=intersectionobserver
        if ('IntersectionObserver' in window) {

            this.observer = new IntersectionObserver(entries => {
                const el = entries[0]
                if (el.isIntersecting) {
                    this.intersected = true
                    this.observer.disconnect() // TODO - Start/Stop observing when this.src changes
                    this.setImageSrc()
                }
                
            }, this.intersectionOptions)

            this.observer.observe(this.$el) // Check if element is within viewport

        } else {
            // Fallback for older browsers
            this.intersected = true
        }

    },

    destroyed() {
        if ('IntersectionObserver' in window) {
            this.observer.disconnect()
        }
    },

    methods: {
        
        setImageSrc() {
            
            // Reset
            this.src = false
            
            // Select image src depending on container width
            for (var i = 0; i < this.data.length; i++) {
                let img = this.data[i]

                // Load asset depending on size
                if (img.width > this.containerWidth) {
                    if (this.src === img.url) {break} // Ignore same size twice!
                    
                    this.src = img.url
                    break
                }
            }
            
            // If no image is large enough, pick the last image
            if (this.src === false) {                
                this.src = this.data[this.data.length-1].url
            }
            
            
            // Update image src if within viewport
            this.imgSrc = (this.intersected === true) ? this.src : false
        },

        onImageLoaded() {
            this.loaded = true
            this.$emit('loaded', this)
        }
    },
        
    watch: {
        containerWidth(newVal) {
            if (newVal > 0) {
                this.setImageSrc()
            }
        }
    }
}
</script>


<style lang="scss" scoped></style>
